import axios from 'axios'
import { showErrorNotification } from '../toastr'
import { success, error } from './response'

function successHandler(callback) {
  return config => {
    if (!navigator.onLine) {
      showErrorNotification(
        'A conexão com a internet não foi detectada, aguarde alguns instantes e tente novamente. Caso a internet não seja reconectada, contate o suporte técnico.'
      )
    }
    if (callback) callback()
    return config
  }
}

function errorHandler(callback) {
  return err => {
    if (callback) callback()
    return Promise.reject(err)
  }
}

function setUpInterceptors() {
  axios.interceptors.response.use(success, error)
}

function customResponseInterceptor(actionSuccess, actionError) {
  axios.interceptors.response.use(
    successHandler(actionSuccess),
    errorHandler(actionError)
  )
}

function customRequestInterceptor(actionSuccess, actionError) {
  axios.interceptors.request.use(
    successHandler(actionSuccess),
    errorHandler(actionError)
  )
}

export {
  setUpInterceptors,
  customResponseInterceptor,
  customRequestInterceptor
}
